import { FaPhone, FaEnvelope, FaGlobe } from "react-icons/fa";
import bgImage2 from "../../assets/bg-background3.svg";
//import logo from "../../assets/KW-Bodrum.png";
import { useState } from "react";

const Card = ({ data }) => {
  const [downloading, setDownloading] = useState(false);

  const handleVCardDownload = () => {
    setDownloading(true);

    const slug = data.slug; // veya props.slug
    // const downloadUrl = `http://localhost/kw-kartvizit/panel/vcard.php?slug=${slug}`;
    const downloadUrl = `https://app.kwbodrum.com.tr/panel/vcard.php?slug=${slug}`;

    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = `${slug}.vcf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Birkaç saniye sonra spinnerı kaldır (bazı tarayıcılarda indirme olayı tam yakalanamıyor)
    setTimeout(() => setDownloading(false), 3000);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: data.full_name || "Keller Williams Bodrum",
        text: `${data.full_name} dijital profiline göz atın!`,
        url: window.location.href,
      })
        .then(() => console.log('Profil başarıyla paylaşıldı!'))
        .catch((error) => console.error('Paylaşım iptal edildi veya hata oluştu:', error));
    } else {
      alert("Tarayıcınız bu paylaşım özelliğini desteklemiyor.");
    }
  };

  const cleanedPhone = data.phone.replace(/\D/g, ""); // Sadece rakamları alır
  const telLink = `tel:+90${cleanedPhone.replace(/^0/, "")}`; // Baştaki 0'ı siler, +90 ekler
  const wplink = `https://wa.me/90${cleanedPhone.replace(/^0/, "")}`;

  return (
    <div style={{
      backgroundImage: `url(${bgImage2})`,
      backgroundColor: "#C5CAFF",
      backgroundSize: "contain",
      backgroundPosition: "top center",
      backgroundRepeat: "no-repeat",
      borderRadius: "20px",
      padding: "20px 20px",
      maxWidth: "350px",
      margin: "auto",
      marginTop: "0px",
      //fontFamily: "sans-serif",
      color: "#4C4D4E",
      textAlign: "center",
      boxShadow: "0 16px 20px rgba(0,0,0,0.25)"
    }}>

      {/* Profil Fotoğrafı */}
      <img
        src={data.foto_url ? data.foto_url : "/profile-picture.png"}
        alt={data.full_name}
        style={{
          width: 170,
          height: 170,
          borderRadius: "15%",
          borderWidth: "5px",
          borderColor: '#FFF',
          borderStyle: "solid",
          objectFit: "cover",
          margin: "80px auto 10px",
          display: "block"
        }}
      />
      {/* İsim ve Ünvan */}
      <h2 style={{ marginBottom: 2, fontSize: 26, fontWeight: 700, letterSpacing: 0 }}>
        {data.full_name}
      </h2>
      <p style={{ margin: 0, fontWeight: 600, marginBottom: 10, fontSize: 14 }}>{data.team && (data.team) + " |"}  {data.unvan}</p>
      {data.bolge && (<p style={{ margin: 0, marginBottom: 10, fontSize: 14 }}><b>Uzmanlık Bölgesi: </b>{data.bolge}</p>)}
      {data.bio && (
        <div style={{
          background: "rgba(88, 88, 88, 0.07)",
          padding: "12px",
          borderRadius: "10px",
          fontSize: "14px",
          color: "#4C4D4E",
          fontStyle: "",
          marginBottom: 10
        }}>
          {data.bio}
        </div>
      )}
      {/* <img src={logo} alt="KW Bodrum" style={{ width: 160, margin: "8px auto 16px" }} /> */}

      {/* Sosyal Medya İkonları */}
      <div style={{ display: "flex", justifyContent: "center", gap: 9, marginBottom: 20, marginTop: 20 }}>
        {data.phone && (
          <a
            href={telLink}
            target="_blank"
            rel="noreferrer"
            style={{
              textDecoration: "none",
              color: "#4C4D4E",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              fontSize: 10,
              transition: "color 0.3s ease"
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = "#D62828")}
            onMouseOut={(e) => (e.currentTarget.style.color = "#4C4D4E")}
          >
            <img
              src="/icons/call-mc.svg"
              alt="Ara"
              style={{
                width: 50,
              }}
            />
            <p style={{ margin: 0 }}>Ara</p>
          </a>
        )}
        {data.instagram && (
          <a href={data.instagram}
            target="_blank"
            rel="noreferrer"
            style={{
              textDecoration: "none",
              color: "#4C4D4E",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              fontSize: 10,
              transition: "color 0.3s ease"
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = "#D62828")}
            onMouseOut={(e) => (e.currentTarget.style.color = "#4C4D4E")}
          >
            <img src="/icons/instagram-mc.svg" alt="Instagram" style={{ width: 50, }} />
            <p style={{ margin: 0 }}>Instagram</p>
          </a>
        )}
        {data.facebook && (
          <a href={data.facebook}  target="_blank"
            rel="noreferrer"
            style={{
              textDecoration: "none",
              color: "#4C4D4E",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              fontSize: 10,
              transition: "color 0.3s ease"
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = "#D62828")}
            onMouseOut={(e) => (e.currentTarget.style.color = "#4C4D4E")}
          >
            <img src="/icons/facebook-mc.svg" alt="Facebook" style={{ width: 50, }} />
            <p style={{ margin: 0 }}>Facebook</p>
          </a>
        )}
        {data.linkedin && (
          <a href={data.linkedin}  target="_blank"
            rel="noreferrer"
            style={{
              textDecoration: "none",
              color: "#4C4D4E",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              fontSize: 10,
              transition: "color 0.3s ease"
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = "#D62828")}
            onMouseOut={(e) => (e.currentTarget.style.color = "#4C4D4E")}
          >
            <img src="/icons/linkedin-mc.svg" alt="Linkedin" style={{ width: 50, }} />
            <p style={{ margin: 0 }}>Linkedin</p>
          </a>
        )}
        {/* //whatsapp */}
        {data.phone && (
          <a href={wplink}  target="_blank"
            rel="noreferrer"
            style={{
              textDecoration: "none",
              color: "#4C4D4E",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              fontSize: 10,
              transition: "color 0.3s ease"
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = "#D62828")}
            onMouseOut={(e) => (e.currentTarget.style.color = "#4C4D4E")}
          >
            <img src="/icons/whatsapp-mc.svg" alt="Whatsapp" style={{ width: 50, }} />
            <p style={{ margin: 0 }}>Whatsapp</p>
          </a>
        )}  
      </div>

      {/* İletişim Bilgileri */}
      <div style={{ textAlign: "left", marginBottom: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
          <FaPhone color="#4754BE" />
          <span>{data.phone}</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
          <FaEnvelope color="#4754BE" />
          <span>{data.email}</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <FaGlobe color="#4754BE" />
          <span>{data.web}</span>
        </div>
      </div>



      {/* Butonlar */}
      <div style={{ display: "flex", gap: 10 }}>
        <button onClick={handleVCardDownload} style={{
          flex: 1,
          background: "#4754BE",
          color: "#fff",
          border: "none",
          padding: "10px",
          borderRadius: "8px",
          fontWeight: 600,
          cursor: "pointer"
        }}>
          {downloading ? (
            <>Rehbere Ekleniyor...</>
          ) : (
            <>
              Rehbere Kaydet
            </>
          )}
        </button>
        <button
          onClick={handleShare}
          style={{
            flex: 1,
            background: "#4754BE",
            color: "#fff",
            border: "none",
            padding: "10px",
            borderRadius: "8px",
            fontWeight: 600,
            cursor: "pointer"
          }}>
          Profili Paylaş
        </button>
      </div>
    </div>
  );
};

export default Card;
